import { Ordered } from "@26lights/orcha";

export function orderedComparator(e1: Ordered, e2: Ordered): number {
  console.log({ e1, e2 });
  return e1.rank.localeCompare(e2.rank);
}
